export const iFrameUrlMock = {
  "pt-BR": "https://usefixit.tawk.help/",
  en: "https://usefixit.tawk.help/en-us",
  es: "https://usefixit.tawk.help/es",
  fr: "https://usefixit.tawk.help/fr",
};
